import { FC, useEffect } from 'react';
import analytics from '@analytics/index';
import { useConsent } from './useConsent';

/**
 * Starts and stops Google Analytics from the consent choice. Until the visitor says yes, it isn't loaded.
 * Renders nothing.
 */
const AnalyticsGate: FC = () => {
    const { analytics: consented } = useConsent();

    useEffect(() => {
        analytics.setConsent(consented);
    }, [consented]);

    return null;
};

export default AnalyticsGate;
